import React from 'react'
import PropTypes from 'prop-types'
import { contactProps } from '../propTypes'

import { withTranslation } from 'react-i18next'

import { ContactNew } from '../../../../entities/ContactNew'
import { Member } from '../../../../entities/Member'

import ContactItem from './ContactItem/ContactItem'
import MemberItem from './MemberItem/MemberItem'

import './ContactCard.css'

const ContactCard = ({ t, contact, dark }) => {
    if (contact instanceof ContactNew) {
        return <ContactItem contact={contact} dark={dark} />
    }

    if (contact instanceof Member) {
        return <MemberItem contact={contact} dark={dark} />
    }
}

ContactCard.propTypes = {
    t: PropTypes.func,
    contact: contactProps,
    dark: PropTypes.bool
}

export { ContactCard }
export default withTranslation()(ContactCard)
